// components/GallerySection.jsx

import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/GallerySection.module.css";
import video from "../assets/fegaropetra-video.mp4";

const images = [
  "https://images.unsplash.com/photo-1514933651103-005eec06c04b?q=80&w=1974&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2070&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=1974&auto=format&fit=crop",
];

export default function GallerySection() {

    const sectionRef = useRef(null);
      const [isVisible, setIsVisible] = useState(false);
    
      useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observer.disconnect(); // run once (important for performance)
            }
          },
          {
            threshold: 0.25, // triggers when 25% visible
          }
        );
    
        if (sectionRef.current) {
          observer.observe(sectionRef.current);
        }
    
        return () => observer.disconnect();
      }, []);

  return (
    <section ref={sectionRef} className={`${styles.section} ${isVisible ? styles.active : ''}`} id="gallery">
      <div className={styles.container}>
        <span>Gallery</span>

        <h2>Moments & Atmosphere</h2>

        <div className={styles.grid}>
          <div className={styles.videoWrapper}>
              <video
                src={video}
                autoPlay
                muted
                loop
                playsInline
                controls
                className={styles.video}
              />
          </div>
          {images.map((image, index) => (
            <div className={styles.imageWrapper} key={index}>
              <img src={image} alt="Restaurant Gallery" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}